// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__JfaIs","label":"Labeled_label__1Zmkb","divider":"Labeled_divider__1JMDo"};